import {
  type FieldsInputField,
  InputFieldInputType,
  type _Number,
  InputFieldNumberComponentType,
  type InputFieldPayment,
  InputFieldPaymentComponentType,
  type _String,
  InputFieldStringComponentType,
} from '@wix/ambassador-forms-v4-form/types';

export function getDefaultValue(
  field?: FieldsInputField,
): string | number | undefined {
  switch (field?.inputType) {
    case InputFieldInputType.STRING:
      return getDefaultStringComponentValue(field.stringOptions) ?? undefined;
    case InputFieldInputType.NUMBER:
      return getDefaultNumberComponentValue(field.numberOptions) ?? undefined;
    case InputFieldInputType.PAYMENT:
      return getDefaultPaymentComponentValue(field.paymentOptions) ?? undefined;
    default:
      return undefined;
  }
}

function getDefaultStringComponentValue(
  stringOptions?: _String,
): string | null | undefined {
  switch (stringOptions?.componentType) {
    case InputFieldStringComponentType.DATE_TIME:
      return stringOptions?.dateTimeOptions?.default;
    case InputFieldStringComponentType.DATE_INPUT:
      return stringOptions?.dateInputOptions?.default;
    case InputFieldStringComponentType.DATE_PICKER:
      return stringOptions?.datePickerOptions?.default;
    case InputFieldStringComponentType.TEXT_INPUT:
      return stringOptions?.textInputOptions?.default;
    case InputFieldStringComponentType.TIME_INPUT:
      return stringOptions?.timeInputOptions?.default;
    default:
      return undefined;
  }
}

function getDefaultNumberComponentValue(
  numberOptions?: _Number,
): number | null | undefined {
  switch (numberOptions?.componentType) {
    case InputFieldNumberComponentType.NUMBER_INPUT:
      return numberOptions?.numberInputOptions?.default;
    case InputFieldNumberComponentType.RATING_INPUT:
      return numberOptions?.ratingInputOptions?.defaultValue;
    default:
      return undefined;
  }
}

function getDefaultPaymentComponentValue(
  paymentOptions?: InputFieldPayment,
): number | null | undefined {
  switch (paymentOptions?.componentType) {
    case InputFieldPaymentComponentType.PAYMENT_INPUT:
      return paymentOptions?.paymentInputOptions?.default;
    default:
      return undefined;
  }
}
